module.exports = __webpack_public_path__ + "b79388cc5e29ac454c81b327e4c3a95f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/cy.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/cy.svg
// module chunks = 0